import * as React from 'react';

import { ExperienceContext } from '@origin-digital/features';

import {
  BANNER,
  DIGITAL_ADOPTION,
  HELP_SUPPORT,
  QUICK_LINKS,
  TOP_LIGHT_CARD,
  TOP_CARD,
} from './staticContent';

import { AppPromo } from '../AppPromo';
import { BannerLoading, BannerImage } from '../BannerImage';
import { COLOURS } from '../../consts/style';
import { getExperienceOffer } from '../../utils/utils';
import { HelpSupport } from '../HelpSupport';
import { mboxes } from '../../consts/mboxes';
import { ProductCards } from '../CardLinks';
import { QuickLinks } from '../QuickLinks';
import { Section } from '../Common';
import { TrustPilot } from '../TrustPilot';
import { WhyOrigin } from '../WhyOrigin';

export const SHOW_ANIMATIONS = true;

export const PageContent = () => {
  const bannerContent = getExperienceOffer(mboxes.bannerMbox);
  const quickLinksContent = getExperienceOffer(mboxes.quickLinksMbox);
  const topCardContent = getExperienceOffer(mboxes.topCardsMbox);
  const whyOriginContent = getExperienceOffer(mboxes.whyOriginMbox);

  return (
    <>
      <ExperienceContext.Consumer>
        {(values) =>
          !values.loading ? (
            <BannerImage data-id="banner-image-orange" {...BANNER} {...bannerContent} />
          ) : (
            <BannerLoading />
          )
        }
      </ExperienceContext.Consumer>
      <Section padding={false} bgColor={COLOURS.GREY.GREY_4}>
        <QuickLinks
          data-id="page-content-quicklinks"
          {...QUICK_LINKS}
          {...quickLinksContent}
          verticalOffset={-32}
          bgColor={COLOURS.GREY.GREY_4}
        />
      </Section>
      <Section bgColor={COLOURS.GREY.GREY_4}>
        <WhyOrigin {...TOP_LIGHT_CARD} {...whyOriginContent} />
      </Section>
      <Section>
        <TrustPilot />
      </Section>
      <Section bgColor={COLOURS.GREY.GREY_8}>
        <ProductCards {...TOP_CARD} {...topCardContent} />
      </Section>
      <Section bgColor={COLOURS.PRIMARY.ORANGE}>
        <AppPromo {...DIGITAL_ADOPTION} />
      </Section>
      <Section>
        <HelpSupport {...HELP_SUPPORT} />
      </Section>
    </>
  );
};
